// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"cda149d1","432":"8238dd6e","460":"aae679ef","806":"55470d9b","829":"0cb2ea36"}[chunkId] + ".chunk.css";
};